import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import s from "../core/Accessor.js";
import { urlToObject as t } from "../core/urlUtils.js";
import { property as o } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as e } from "../core/accessorSupport/decorators/subclass.js";

var i = /*#__PURE__*/function (_s) {
  _inherits(i, _s);

  var _super = _createSuper(i);

  function i() {
    var _this;

    _classCallCheck(this, i);

    for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
      r[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(r)), _this.requestOptions = null, _this.url = null;
    return _this;
  }

  _createClass(i, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(r, s) {
      return "string" != typeof r ? r : _objectSpread({
        url: r
      }, s);
    }
  }, {
    key: "parsedUrl",
    get: function get() {
      return this._parseUrl(this.url);
    }
  }, {
    key: "_parseUrl",
    value: function _parseUrl(r) {
      return r ? t(r) : null;
    }
  }, {
    key: "_encode",
    value: function _encode(r, s, t) {
      var o = {};

      for (var _e in r) {
        if ("declaredClass" === _e) continue;
        var _i2 = r[_e];
        if (null != _i2 && "function" != typeof _i2) if (Array.isArray(_i2)) {
          o[_e] = [];

          for (var _r = 0; _r < _i2.length; _r++) {
            o[_e][_r] = this._encode(_i2[_r]);
          }
        } else if ("object" == typeof _i2) {
          if (_i2.toJSON) {
            var _r2 = _i2.toJSON(t && t[_e]);

            o[_e] = s ? _r2 : JSON.stringify(_r2);
          } else o[_e] = s ? _i2 : JSON.stringify(_i2);
        } else o[_e] = _i2;
      }

      return o;
    }
  }]);

  return i;
}(s);

r([o({
  readOnly: !0
})], i.prototype, "parsedUrl", null), r([o()], i.prototype, "requestOptions", void 0), r([o({
  type: String
})], i.prototype, "url", void 0), i = r([e("esri.tasks.Task")], i);
var l = i;
export { l as default };